import classNames from 'classnames'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Icon } from '@campgladiator/cgui-core.atoms.icon'
import { Tag } from '@campgladiator/cgui-core.atoms.tag'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import {
  analytics,
  analyticsEvent,
  analyticsEventLabel,
} from '../../../../common/utility/analytics'
import { getDayOfWeekName } from '../../../../common/utility/time'
import { VirtualWorkoutsProps, WorkoutCardProps } from '../../TrainerBio.d'
import { OverflowContainer } from '../OverflowContainer'
import styles from './VirtualWorkouts.module.scss'

const { trackCustomEvent } = analytics
const { LIST_ITEM, PAGINATE } = analyticsEvent
const {
  TRAINER_BIO: { VIRTUAL_WORKOUT_CARD, VIRTUAL_WORKOUTS },
} = analyticsEventLabel

const WorkoutCard = ({ isTabletSmall, workout }: WorkoutCardProps) => {
  const date = new Date(workout.datetime)
  const dayOfTheWeek = getDayOfWeekName(date.getDay())
  const time = date.toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
  })
  return (
    <Card
      flat
      key={workout.id}
      onClick={() => trackCustomEvent(LIST_ITEM(VIRTUAL_WORKOUT_CARD))}
      className={classNames(styles.card, {
        [styles.live]: workout.live,
      })}
    >
      <Icon
        className={classNames(styles.icon, {
          [styles.live]: workout.live,
        })}
        name="icon-video-line"
      />
      <div className={styles.bottom}>
        <div className={styles.date}>
          <Paragraph
            className={styles.day}
            size={isTabletSmall ? 'xsmall' : 'small'}
            weight="book"
          >
            {dayOfTheWeek}
          </Paragraph>
          <Paragraph size={isTabletSmall ? 'xsmall' : 'small'} weight="bold">
            {time}
          </Paragraph>
        </div>
        {workout.live && (
          <Tag size={isTabletSmall ? 'tiny' : 'xsmall'} variation="red-white">
            • Live
          </Tag>
        )}
      </div>
    </Card>
  )
}

const VirtualWorkouts = ({
  className = '',
  isTabletSmall,
  workouts,
  ...props
}: VirtualWorkoutsProps) => {
  const hasWorkouts = !!workouts.length

  return hasWorkouts ? (
    <section className={classNames(styles.wrapper, className)} {...props}>
      <OverflowContainer
        className={classNames(styles.workouts, {
          [styles.columnOrder]: workouts.length > 2,
        })}
        heading="Virtual Workouts"
        scrollOnClick={() => trackCustomEvent(PAGINATE(VIRTUAL_WORKOUTS))}
      >
        {workouts.map((workout) => (
          <WorkoutCard
            isTabletSmall={isTabletSmall}
            key={workout.id}
            workout={workout}
          />
        ))}
      </OverflowContainer>
    </section>
  ) : null
}

export default VirtualWorkouts
